
import "./player.scss";
import PlayerInfo from "../../features/player/PlayerInfo";
import PlayerInfoSearch from "../../features/player/PlayerInfoSearch";
import PlayerInfoCopy from "../../features/player/PlayerInfoCopy";
import ScrollToTop from "../../shared/components/common/ScrollToTop";
import { Card, Select, Typography, Space, Row, Col, Divider } from 'antd';
import { DatabaseOutlined } from '@ant-design/icons';
import { ENV, ROLE, IS_DOCKER, SERVER_CONFIG, getServerOptions } from "../../shared/utils/enum";
import React, { useContext, useEffect, useState } from "react";
import { defaultPlayerData } from "../../shared/contexts/playerContext";
import { AuthContext } from "../../shared/contexts/authContext";
import { DarkModeContext } from "../../shared/contexts/darkModeContext";

const { Text } = Typography;
const { Option } = Select;

const PlayerCopy = () => {
    const { currentUser } = useContext(AuthContext);
    const { darkMode } = useContext(DarkModeContext);
    const [playerDataLeft, setPlayerDataLeft] = useState(defaultPlayerData);
    const [playerDataRight, setPlayerDataRight] = useState(defaultPlayerData);
    const [leftDB, setLeftDB] = useState(ENV.DEVELOP);
    const [rightDB, setRightDB] = useState(IS_DOCKER ? ENV.DOCKER : ENV.DEVELOP);

    useEffect(() => {
        return () => {
            setPlayerDataLeft(defaultPlayerData);
            setPlayerDataRight(defaultPlayerData);
        };
    }, []);

    const handleChangeEnv = (dir, value) => {
        dir ? setLeftDB(value) : setRightDB(value);
    }

    const renderServerSelector = (title, value, onChange, isLeft = true) => (
        <Card
            size="small"
            className={`server-selector-card ${darkMode ? 'dark-theme' : 'light-theme'}`}
            style={{
                marginBottom: 16,
                borderRadius: '8px',
                border: `1px solid var(--border-color)`,
                background: `var(--card-background)`,
            }}
        >
            <Space align="center" size="middle" style={{ width: '100%' }}>
                <DatabaseOutlined style={{ color: isLeft ? '#52c41a' : '#722ed1', fontSize: '16px' }} />
                <div style={{ flex: 1 }}>
                    <Text strong style={{ color: 'var(--text-primary)', fontSize: '14px' }}>
                        {title}
                    </Text>
                </div>
                <Select
                    value={value}
                    onChange={onChange}
                    style={{ width: 200 }}
                    size="middle"
                    className="server-select"
                >
                    {getServerOptions({ allServers: isLeft }).map(env => {
                        if (!isLeft && env === ENV.PRODUCTION && currentUser.role !== ROLE.SUPER) return null;
                        const config = SERVER_CONFIG[env];
                        return (
                            <Option key={env} value={env}>
                                <Space>
                                    <span>{config.icon}</span>
                                    {env === ENV.PRODUCTION ? (
                                        <Text style={{ color: '#1890ff', fontWeight: 'bold' }}>
                                            {config.fullLabel}
                                        </Text>
                                    ) : (
                                        <span>{config.fullLabel}</span>
                                    )}
                                </Space>
                            </Option>
                        );
                    })}
                </Select>
            </Space>
        </Card>
    );

    return (
        <div className='player-copy-main' style={{ padding: '24px' }}>
            <Row gutter={[24, 24]}>
                {/* 왼쪽: Source Database */}
                <Col xs={24} lg={11}>
                    <div className="source-section">
                        {renderServerSelector('Source Database', leftDB, (value) => handleChangeEnv(1, value), true)}
                        <PlayerInfoSearch db={leftDB} setPlayerData={setPlayerDataLeft} />
                        <Divider style={{ margin: '24px 0', borderColor: 'var(--border-color)' }} />
                        <PlayerInfo playerData={playerDataLeft} setPlayerData={setPlayerDataLeft} isCopy={true} />
                    </div>
                </Col>

                {/* 가운데: Copy Action */}
                <Col xs={24} lg={2}>
                    <div style={{
                        position: 'sticky',
                        top: '24px',
                        display: 'flex',
                        justifyContent: 'center',
                        paddingTop: '100px'
                    }}>
                        <PlayerInfoCopy
                            leftDB={leftDB}
                            playerDataLeft={playerDataLeft}
                            rightDB={rightDB}
                            playerDataRight={playerDataRight}
                        />
                    </div>
                </Col>

                {/* 오른쪽: Target Database */}
                <Col xs={24} lg={11}>
                    <div className="target-section">
                        {renderServerSelector('Target Database', rightDB, (value) => handleChangeEnv(0, value), false)}
                        <PlayerInfoSearch db={rightDB} setPlayerData={setPlayerDataRight} />
                        <Divider style={{ margin: '24px 0', borderColor: 'var(--border-color)' }} />
                        <PlayerInfo playerData={playerDataRight} setPlayerData={setPlayerDataRight} isCopy={true} />
                    </div>
                </Col>
            </Row>
            <ScrollToTop />
        </div>
    );
}

export default PlayerCopy;